import { websiteBuilderGenerateDefaultButton } from "../../element/websiteBuilderButton";
import { WebsiteBuilderDividerWeight, websiteBuilderGenerateDefaultDivider } from "../../element/websiteBuilderDivider";
import { websiteBuilderGenerateDefaultHeading } from "../../element/websiteBuilderHeading";
import { websiteBuilderGenerateDefaultParagraph } from "../../element/websiteBuilderParagraph";
import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderContent, websiteBuilderGenerateDefaultContent } from "../websiteBuilderContent";
import { websiteBuilderGenerateTemplateImage } from "./websiteBuilderResolveTemplateMedia";

export function websiteBuilderCourseOverviewTemplate(media: IWebsiteBuilderMediaItem[]): IWebsiteBuilderContent {
  const section = websiteBuilderGenerateDefaultContent();
  const courseImage = websiteBuilderGenerateTemplateImage(media, "edwin-compton");
  const subHeading = websiteBuilderGenerateDefaultParagraph();
  const subHeadingDivider = websiteBuilderGenerateDefaultDivider();
  const heading = websiteBuilderGenerateDefaultHeading();
  const firstParagraph = websiteBuilderGenerateDefaultParagraph();
  const secondParagraph = websiteBuilderGenerateDefaultParagraph();
  const holesValue = websiteBuilderGenerateDefaultHeading();
  const holesLabel = websiteBuilderGenerateDefaultParagraph();
  const parValue = websiteBuilderGenerateDefaultHeading();
  const parLabel = websiteBuilderGenerateDefaultParagraph();
  const yardsValue = websiteBuilderGenerateDefaultHeading();
  const yardsLabel = websiteBuilderGenerateDefaultParagraph();
  const button = websiteBuilderGenerateDefaultButton();

  section.section.layout.desktop.height = 730;
  section.section.layout.tablet.height = 530;
  section.section.layout.mobile.height = 520;

  courseImage.element.layout.desktop.position = { x: 500, y: 0 };
  courseImage.element.layout.tablet.position = { x: 384, y: 0 };
  courseImage.element.layout.mobile.position = { x: 0, y: 0 };
  courseImage.element.layout.desktop.dimensions = { width: 500, height: 730 };
  courseImage.element.layout.tablet.dimensions = { width: 384, height: 530 };
  courseImage.element.layout.mobile.dimensions = { width: 320, height: 520 };
  courseImage.element.settings.alt = "Golf course bunker"; // TODO: Translation;
  courseImage.element.visibility.mobile = false;

  subHeading.element.layout.desktop.position = { x: 80, y: 115 };
  subHeading.element.layout.tablet.position = { x: 32, y: 59 };
  subHeading.element.layout.mobile.position = { x: 25, y: 46 };
  subHeading.element.layout.desktop.dimensions = { width: 85, height: 25 };
  subHeading.element.layout.tablet.dimensions = { width: 85, height: 25 };
  subHeading.element.layout.mobile.dimensions = { width: 85, height: 25 };
  subHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "12px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "OUR COURSE", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  subHeadingDivider.element.layout.desktop.position = { x: 170, y: 124 };
  subHeadingDivider.element.layout.tablet.position = { x: 122, y: 68 };
  subHeadingDivider.element.layout.mobile.position = { x: 115, y: 55 };
  subHeadingDivider.element.layout.desktop.dimensions = { width: 125, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.tablet.dimensions = { width: 100, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.mobile.dimensions = { width: 90, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.settings.weight = WebsiteBuilderDividerWeight.THIN;
  subHeadingDivider.element.settings.color = "#285E1A";

  heading.element.layout.desktop.position = { x: 80, y: 150 };
  heading.element.layout.tablet.position = { x: 32, y: 94 };
  heading.element.layout.mobile.position = { x: 25, y: 81 };
  heading.element.layout.desktop.dimensions = { width: 390, height: 105 };
  heading.element.layout.tablet.dimensions = { width: 320, height: 80 };
  heading.element.layout.mobile.dimensions = { width: 270, height: 75 };
  heading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "44px",
        tablet: "32px",
        mobile: "30px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1, lineHeight: "1.15" },
      content: [{
        type: "text",
        text: "Exceptional golf is just the start.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  firstParagraph.element.layout.desktop.position = { x: 80, y: 265 };
  firstParagraph.element.layout.tablet.position = { x: 32, y: 184 };
  firstParagraph.element.layout.mobile.position = { x: 25, y: 166 };
  firstParagraph.element.layout.desktop.dimensions = { width: 390, height: 85 };
  firstParagraph.element.layout.tablet.dimensions = { width: 320, height: 70 };
  firstParagraph.element.layout.mobile.dimensions = { width: 270, height: 95 };
  firstParagraph.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.3" },
      content: [{
        type: "text",
        text: "Our 18 hole course is more than just a place to play — it's a gathering ground where friendships are forged, memories are made, and a deep love of the game is passed from one generation to the next.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  secondParagraph.element.layout.desktop.position = { x: 80, y: 365 };
  secondParagraph.element.layout.tablet.position = { x: 32, y: 264 };
  secondParagraph.element.layout.mobile.position = { x: 25, y: 267 };
  secondParagraph.element.layout.desktop.dimensions = { width: 390, height: 75 };
  secondParagraph.element.layout.tablet.dimensions = { width: 320, height: 70 };
  secondParagraph.element.layout.mobile.dimensions = { width: 270, height: 80 };
  secondParagraph.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "15px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      attrs: { lineHeight: "1.3" },
      content: [{
        type: "text",
        text: "Set against a breathtaking landscape of rolling fairways, mature trees, and serene water features, every round here is a journey through nature at its finest.", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  holesValue.element.layout.desktop.position = { x: 80, y: 455 };
  holesValue.element.layout.tablet.position = { x: 32, y: 339 };
  holesValue.element.layout.mobile.position = { x: 25, y: 346 };
  holesValue.element.layout.desktop.dimensions = { width: 70, height: 45 };
  holesValue.element.layout.tablet.dimensions = { width: 70, height: 40 };
  holesValue.element.layout.mobile.dimensions = { width: 70, height: 40 };
  holesValue.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "38px",
        tablet: "30px",
        mobile: "28px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1 },
      content: [{
        type: "text",
        text: "18",
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  holesLabel.element.layout.desktop.position = { x: 80, y: 505 };
  holesLabel.element.layout.tablet.position = { x: 32, y: 382 };
  holesLabel.element.layout.mobile.position = { x: 25, y: 386 };
  holesLabel.element.layout.desktop.dimensions = { width: 70, height: 25 };
  holesLabel.element.layout.tablet.dimensions = { width: 70, height: 25 };
  holesLabel.element.layout.mobile.dimensions = { width: 70, height: 25 };
  holesLabel.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "14px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "Holes", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  parValue.element.layout.desktop.position = { x: 180, y: 455 };
  parValue.element.layout.tablet.position = { x: 132, y: 339 };
  parValue.element.layout.mobile.position = { x: 115, y: 346 };
  parValue.element.layout.desktop.dimensions = { width: 70, height: 45 };
  parValue.element.layout.tablet.dimensions = { width: 70, height: 40 };
  parValue.element.layout.mobile.dimensions = { width: 70, height: 40 };
  parValue.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "38px",
        tablet: "30px",
        mobile: "28px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1 },
      content: [{
        type: "text",
        text: "71",
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  parLabel.element.layout.desktop.position = { x: 180, y: 505 };
  parLabel.element.layout.tablet.position = { x: 132, y: 382 };
  parLabel.element.layout.mobile.position = { x: 115, y: 386 };
  parLabel.element.layout.desktop.dimensions = { width: 70, height: 25 };
  parLabel.element.layout.tablet.dimensions = { width: 70, height: 25 };
  parLabel.element.layout.mobile.dimensions = { width: 70, height: 25 };
  parLabel.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "14px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "Par", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  yardsValue.element.layout.desktop.position = { x: 280, y: 455 };
  yardsValue.element.layout.tablet.position = { x: 232, y: 339 };
  yardsValue.element.layout.mobile.position = { x: 205, y: 346 };
  yardsValue.element.layout.desktop.dimensions = { width: 120, height: 45 };
  yardsValue.element.layout.tablet.dimensions = { width: 100, height: 40 };
  yardsValue.element.layout.mobile.dimensions = { width: 90, height: 40 };
  yardsValue.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "38px",
        tablet: "30px",
        mobile: "28px",
      },
    },
    content: [{
      type: "heading",
      attrs: { level: 1 },
      content: [{
        type: "text",
        text: "6,800",
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  yardsLabel.element.layout.desktop.position = { x: 280, y: 505 };
  yardsLabel.element.layout.tablet.position = { x: 232, y: 382 };
  yardsLabel.element.layout.mobile.position = { x: 205, y: 386 };
  yardsLabel.element.layout.desktop.dimensions = { width: 120, height: 25 };
  yardsLabel.element.layout.tablet.dimensions = { width: 100, height: 25 };
  yardsLabel.element.layout.mobile.dimensions = { width: 90, height: 25 };
  yardsLabel.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "14px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "Yards", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#101828",
          },
        }],
      }],
    }],
  };

  button.element.layout.desktop.position = { x: 80, y: 570 };
  button.element.layout.tablet.position = { x: 32, y: 432 };
  button.element.layout.mobile.position = { x: 25, y: 435 };
  button.element.layout.desktop.dimensions = { width: 140, height: 44 };
  button.element.layout.tablet.dimensions = { width: 140, height: 44 };
  button.element.layout.mobile.dimensions = { width: 140, height: 44 };
  button.element.settings.label = "View scorecard"; // TODO: Translation
  button.element.settings.backgroundColor = "#285E1A";
  button.element.settings.borderColor = "#285E1A";
  button.element.settings.color = "#FFFFFF";
  button.element.settings.borderRadius = 10;

  section.children = [
    courseImage,
    subHeading,
    subHeadingDivider,
    heading,
    firstParagraph,
    secondParagraph,
    holesValue,
    holesLabel,
    parValue,
    parLabel,
    yardsValue,
    yardsLabel,
    button,
  ];

  return section;
}
